import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { AuthTokenService } from '@core/authentication/auth-token.service';
import { RoleTypes } from '@core/authentication/shared/role-types.enum';

@Injectable({
    providedIn: 'root',
})
export class NotAllowAdministratorsGuardService implements CanActivate {

    constructor(
        private authTokenService: AuthTokenService,
        private router: Router,
    ) { }

    public canActivate(): boolean {
        // tslint:disable-next-line:no-bitwise
        if (this.authTokenService.role & (RoleTypes.InternalUsers || RoleTypes.InternalAdministrators)) {
            this.router.navigate(['page-forbidden']);

            return false;
        }

        return true;
    }

}
